import { useNavigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { imgUrl } from "@/lib/api";

// A "Sponsored" card injected into the Shop grid. Supports promoted BTC
// listings (navigate to product) and external banner ads (open in new tab).
export default function SponsoredCard({ ad }) {
  const navigate = useNavigate();
  const isProduct = ad.ad_type === "product";

  const handleClick = () => {
    if (isProduct) navigate(`/product/${ad.product_id}`);
    else if (ad.target_url) window.open(ad.target_url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      data-testid={`sponsored-card-${ad.id}`}
      onClick={handleClick}
      className="bg-white border border-[#E8956B]/40 rounded-2xl overflow-hidden hover:border-[#E8956B] hover:shadow-[0_14px_34px_rgba(232,149,107,0.18)] transition-all duration-300 group relative flex flex-col cursor-pointer ring-1 ring-[#E8956B]/10"
    >
      <div className="relative aspect-square overflow-hidden bg-neutral-100">
        <span className="absolute top-3 left-3 z-10 bg-neutral-900/85 text-white text-[10px] font-bold px-2 py-1 rounded tracking-wider">
          {ad.featured ? "FEATURED BRAND" : "SPONSORED"}
        </span>
        {!isProduct && (
          <span className="absolute top-3 right-3 z-10 bg-white/90 backdrop-blur text-[#CE744A] rounded-full p-1.5 shadow-sm">
            <ExternalLink size={12} />
          </span>
        )}
        <img
          src={imgUrl(ad.image)}
          alt={ad.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-semibold text-neutral-900 text-sm leading-tight line-clamp-2">{ad.title}</h3>
        {isProduct ? (
          <>
            {ad.brand && <p className="text-xs text-neutral-500 mt-1">{ad.brand}</p>}
            <div className="mt-2">
              <span className="text-lg font-bold text-neutral-900">${Number(ad.price).toFixed(2)}</span>
            </div>
          </>
        ) : (
          <p className="text-xs text-neutral-500 mt-1 line-clamp-2">
            Ad by {ad.advertiser_name || "a partner"}
          </p>
        )}
        <div className="mt-3">
          <span className="w-full inline-flex items-center justify-center gap-1.5 border-2 border-[#E8956B] text-[#E8956B] group-hover:bg-[#E8956B] group-hover:text-white font-bold rounded-full py-2 text-sm transition-all">
            {isProduct ? "Shop Now" : <>Visit site <ExternalLink size={13} /></>}
          </span>
        </div>
      </div>
    </div>
  );
}
